import tippy from 'tippy.js'
import { createApp, h } from 'vue'
import 'tippy.js/dist/tippy.css'

class Tippy {
	el = null
	binding = null
	instance = null

	mounted(el, binding) {
		if (typeof binding.value == 'object' && binding.value.component) {
			const { component, props = {}, options = {} } = binding.value

			this.instance = tippy(el, {
				...options,
				render() {
					const container = document.createElement('div')

					const app = createApp(h(component, props))
					app.mount(container)

					return {
						popper: container,
						onDestroy: () => {
							app.unmount
						}
					}
				}
			})
		} else {
			tippy(el, {
				content: binding.value,
				...binding.modifiers,
			})
		}
	}

	unmounted(el) {
		if (el._tippy) {
			el._tippy.destroy()
		}
		if (this.instance) {
			this.instance.destroy()
		}
	}
}

export const installTippy = (app) => {
	const instance = new Tippy()

	app.directive('tippy', {
		// created: instance.created.bind(instance),
		// updated: instance.updated.bind(instance),
		mounted: instance.mounted.bind(instance),
		unmounted: instance.unmounted.bind(instance),
	})
}
